export const schemaNotices = (value) => {
  return {
    name: value?.name || '',
    title: value?.title || '',
    message: value?.message || '',
    notDelete: value?.notDelete || '',
    limitRead: Number(value?.limitRead) || 0,
    type: value?.type,
  }
}

export const schemaAlert = (value) => {
  return {
    title: value?.title || '',
    msg: value?.msg || '',
    notDelete: value?.notDelete || '',
    visible: value?.visible || '',
    type: value?.type || '',
    expiredAt: value?.expiredAt || '',
  }
}
